import { Checkbox } from '@cko/primitives';
import React from 'react';

type PermissionToggleProps = {
  value: boolean;
  initialValue: boolean;
  label: string;
  onToggle: VoidFunction;
};

export const PermissionToggle = (props: PermissionToggleProps) => {
  const { value, initialValue, label, onToggle } = props;
  const isOverridden = initialValue !== value;

  return (
    <Checkbox
      label={label}
      checked={value}
      onChange={onToggle}
      warningText={isOverridden ? 'value overridden' : undefined}
    />
  );
};
